import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/index";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// import '@babel/polyfill'

import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import i18n from './i18n/index';
import global from "./global/global";
import './assets/style/commBody.css'
import store from './store'



const app =createApp(App)
app.pro
app.use(router)
app.use(ElementPlus, {
    locale: zhCn,
})
app.use(i18n)
app.use(store)
app.mount('#app')

